import { modalUtils } from './modalUtils';

export const restrictedAccess = {
	init: () => {
		replaceUrlHash();
		handleRestrictedLinks();
	},
};

function replaceUrlHash() {
	const url = new URL( window.location.href );
	const hash = url.hash;
	if ( hash === '#restricted-link' ) {
		url.hash = '#modal-' + getCorrectRestrictedModalKey();
		history.replaceState( null, null, url );
	}
}

function getCorrectRestrictedModalKey() {
	if ( userIsLoggedIn() ) {
		return 'restricted';
	} else {
		return 'login';
	}
}

function handleRestrictedLinks() {
	document.addEventListener( 'click', ( event ) => {
		if ( event.target.tagName !== 'A' ) {
			return;
		}
		if ( event.target.getAttribute( 'href' ) !== '#restricted-link' ) {
			return;
		}
		const modalId = getCorrectRestrictedModalKey() + 'Modal';
		modalUtils.openModal( document.getElementById( modalId ) );
	} );
}

function userIsLoggedIn() {
	return document.querySelector( 'body' ).classList.contains( 'logged-in' );
}
